import request from './request';

function coachBasePath(campaignId) {
  return `/api/crowdpacs/${campaignId}/campaign-coach`;
}

export function chatUrl(campaignId) {
  return `${coachBasePath(campaignId)}/chat`;
}

export function fetchConversations(campaignId, params = {}) {
  return request('get', `${coachBasePath(campaignId)}/conversations`, params);
}

export function fetchConversationMessages(campaignId, conversationId, params = {}) {
  return request('get', `${coachBasePath(campaignId)}/conversations/${conversationId}`, params);
}

export function fetchCoachContext(campaignId) {
  return request('get', `${coachBasePath(campaignId)}/context`);
}

export function fetchCoachSettings(campaignId) {
  return request('get', `${coachBasePath(campaignId)}/settings`);
}

export function fetchCoachEmails(campaignId, params = {}) {
  return request('get', `${coachBasePath(campaignId)}/emails`, params);
}

export function fetchCoachEmail(campaignId, emailId) {
  return request('get', `${coachBasePath(campaignId)}/emails/${emailId}`);
}

export function updateCoachSettings(campaignId, settings) {
  return request('put', `${coachBasePath(campaignId)}/settings`, settings);
}

export function updateCoachEnabled(campaignId, enabled) {
  return request('post', `/apiv2/crowdpac/${campaignId}/update`, {
    coach_enabled: Boolean(enabled),
  });
}

export function sendFeedback(campaignId, { email, subject, message, message_context }) {
  return request('post', `${coachBasePath(campaignId)}/feedback`, { email, subject, message, message_context });
}

export function updateAutomaticAction(campaignId, automaticActionId, payload) {
  return request('patch', `${coachBasePath(campaignId)}/automatic-actions/${automaticActionId}`, { payload });
}

export function confirmAutomaticAction(campaignId, automaticActionId) {
  return request('post', `${coachBasePath(campaignId)}/automatic-actions/${automaticActionId}/confirm`);
}

export function cancelAutomaticAction(campaignId, automaticActionId) {
  return request('post', `${coachBasePath(campaignId)}/automatic-actions/${automaticActionId}/cancel`);
}

export function getCsrfToken() {
  return document.querySelector('#csrf-token')?.value || document.querySelector('meta[name="csrf-token"]')?.content || '';
}
